import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
  selector: 'app-dashboard-counter',
  templateUrl: './dashboard-counter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dashboard-counter.component.scss']
})
export class DashboardCounterComponent  {
  readonly counter = input<number|undefined>(undefined);
  readonly title = input<string|undefined>(undefined);
}
